import { FC } from 'react';

export type BadgeVariant =
  | 'info'
  | 'success'
  | 'waiting'
  | 'danger'
  | 'dark'
  | 'blue'
  | 'red'
  | 'green'
  | 'orange'
  | 'purple'
  | 'yellow'
  | 'pink'
  | 'teal'
  | 'lime'
  | 'azure'
  | 'black'
  | 'indigo'
  | 'cyan'
  | 'default';

export type IBadgeProps = {
  label: string;
  variant?: BadgeVariant;
};

const Badge: FC<IBadgeProps> = ({variant, label}) => {
  const getBadgeColor = (variant: BadgeVariant) => {
    switch (variant) {
      case 'info':
        return 'bg-blue-lt';
      case 'dark':
        return 'bg-dark-lt';
      case 'success':
        return 'bg-green-lt';
      case 'waiting':
        return 'bg-orange-lt';
      case 'danger':
        return 'bg-red-lt';
      case 'purple':
        return 'bg-purple-lt';
      case 'yellow':
        return 'bg-yellow-lt';
      case 'pink':
        return 'bg-pink-lt';
      case 'teal':
        return 'bg-teal-lt';
      case 'lime':
        return 'bg-lime-lt';
      case 'azure':
        return 'bg-azure-lt';
      case 'indigo':
        return 'bg-indigo-lt';
      case 'blue':
        return 'bg-blue-lt';
      case 'red':
        return 'bg-red-lt';
      case 'orange':
        return 'bg-orange-lt';
      case 'yellow':
        return 'bg-yellow-lt';
      case 'lime':
        return 'bg-lime-lt';
      case 'green':
        return 'bg-green-lt';
      case 'cyan':
        return 'bg-cyan-lt';
      case 'black':
        return 'bg-dark-lt';
      default:
        return 'bg-default-lt';
    }
  };

  const color = getBadgeColor(variant);

  return <span className={`badge ${color}`}>{label}</span>;
};

export default Badge;
